import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IDocumentDestinationService } from '../../model/interfaces/idocumentdestinationservice';

@Injectable({ providedIn: 'root' })
export class InveniasDocumentDestinationService implements IDocumentDestinationService {
  // not implemented for invenias yet;
  documentDestinationOptionsAllowed = false;
  fileTypeOptionsAllowed = true;
  documentDestinationMeta$: any;
  loading$ = new BehaviorSubject<boolean>(false);

  getDocumentDestinationOptions(): undefined {
    return undefined;
  }

  getMetaLabelFromDestinationPath(): undefined {
    return undefined;
  }

  getEntityTypeFromDestinationPath(): undefined {
    return undefined;
  }

  getDestinationsForOutputFileType(): undefined {
    return undefined;
  }
}
